import React from "react";
import { Link } from "@reach/router";
import styled from "styled-components";

const StyledError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 30px;
  margin-top: 100px;
  .err-btn {
    text-align: center;
    color: white;
    margin-top: 5rem;
    background-color: #ff363f;
    padding: 1rem;
    border-radius: 30px;
    border: none;
  }
`;

const BtnWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  row-gap: 1rem;
  column-gap: 1rem;
  align-items: center;
  justify-content: center;
`;

function ErrorDisplay({ status, msg }) {
  return (
    <StyledError>
      <h2>
        {status} - {msg}
      </h2>
      <BtnWrapper>
        <Link className="err-btn" to={"/"}>
          Back to Home
        </Link>
      </BtnWrapper>
    </StyledError>
  );
}

export default ErrorDisplay;
